import { Component, Injector, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { jkGlb, MaterialModule, PageKind, UiModeType, } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, jkSingleComponent } from 'jk-advcom';
import { OpenwinService, templateUrlConfigUty } from '../_service_uty';
import { OpenwinEditComponent, } from '../_edit_uty';


@Component({
  selector: 'app-utypi02',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './utypi02Pkg.component.html', // templateUrlConfigUty.utypi02,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utypi02Component extends jkSingleComponent implements OnInit {
  override _programId = 'utypi02';
  constructor() {
    super();
    this.srv = new OpenwinService();
    this.uiMode = UiModeType.dialog;
    this.pageKind = PageKind.master;
    if (jkGlb.env.appId.toUpperCase() === 'PVI') {
      this.title = '萬用查詢建立-pvi';
      this.qbeConfig.addField = 'MA002,MA006,MA047,Title,PS';
      this.qbeConfig.addWhere = '';
    } else {
      this.title = '開窗SQL建立';
      this.qbeConfig.addField = 'ITEM,MA002,MA006,MA047,Title,PS';
      this.qbeConfig.addWhere = '';
    }
    this.gridInitOpt = { programId: this.programId, sortField: 'ITEM', sort: 'asc', defaultSort: null, pageKind: PageKind.master };
    this.masterEditPage = OpenwinEditComponent;


    //this.constructorInit();
  }

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    //this.srv.cdr = this.cdr;
  };


}
